import DateDiff from 'date-diff';

type ExpirationUnits = {
    expirationDaysCountdown: number;
    expirationHoursCountdown: number;
    expirationMinutesCountdown: number;
};

const now = new Date();

const getCountdouwnDaysHoursMinutes = (myRenawalDate: string | null): ExpirationUnits => {
    const expirationDaysCountdown =
        Math.floor(new DateDiff(new Date(myRenawalDate as string), now).days()) > 0
            ? Math.floor(new DateDiff(new Date(myRenawalDate as string), now).days())
            : 0;

    const expirationHoursCountdown =
        Math.floor(
            new DateDiff(new Date(myRenawalDate as string), now).hours() -
                24 * expirationDaysCountdown
        ) > 0
            ? Math.floor(
                  new DateDiff(new Date(myRenawalDate as string), now).hours() -
                      24 * expirationDaysCountdown
              )
            : 0;

    const expirationMinutesCountdown =
        Math.floor(
            new DateDiff(new Date(myRenawalDate as string), now).minutes() -
                expirationDaysCountdown * 24 * 60 -
                expirationHoursCountdown * 60
        ) > 0
            ? Math.floor(
                  new DateDiff(new Date(myRenawalDate as string), now).minutes() -
                      expirationDaysCountdown * 24 * 60 -
                      expirationHoursCountdown * 60
              )
            : 0;

    return {
        expirationDaysCountdown,
        expirationHoursCountdown,
        expirationMinutesCountdown
    };
};

export default getCountdouwnDaysHoursMinutes;
